// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-player-ws-flv-king-container[data-v-0041f606]{min-height:169px;min-width:300px;width:100%;height:100%;box-sizing:border-box;background:#000;position:relative}.ws-flv-style[data-v-0041f606]{width:100%!important;height:100%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
